import PropTypes from 'prop-types';
import React from 'react';
import CollegeApplicationStatusMenu from 'shared/college-application-status/components/college-application-status-menu';
import CollegeApplicationStatusQuestion from 'shared/college-application-status/components/college-application-status-question';

class CollegeApplicationStatusQuestionMenu extends React.Component {
  static propTypes = {
    college: PropTypes.object.isRequired,
    collegeApplicationStatus: PropTypes.object.isRequired,
    setCollegeAppStatus: PropTypes.func.isRequired,
    questionButtonOnClick: PropTypes.func.isRequired,
    segmentEventLocation: PropTypes.string,
  };

  render() {
    const {
      college,
      collegeApplicationStatus,
      setCollegeAppStatus,
      questionButtonOnClick,
      segmentEventLocation,
    } = this.props;

    let statusComponent = null;

    if (collegeApplicationStatus) {
      statusComponent = (
        <CollegeApplicationStatusMenu
          college={college}
          collegeApplicationStatus={collegeApplicationStatus}
          setCollegeAppStatus={setCollegeAppStatus}
          showStatusContent
          menuButtonColor="white"
          className="college-cards-app-status-section"
          showKebabOnMobile={false}
          segmentEventLocation={segmentEventLocation}
        />
      );
    } else {
      statusComponent = (
        <CollegeApplicationStatusQuestion
          college={college}
          setCollegeAppStatus={setCollegeAppStatus}
          collegeApplicationQuestion="planning-to-apply"
          onClick={questionButtonOnClick}
          segmentEventLocation={segmentEventLocation}
        />
      );
    }

    return <div className="college-application-status-question-menu">{statusComponent}</div>;
  }
}

export default CollegeApplicationStatusQuestionMenu;
